<div class="backgroundImage">
    <app-header login= 'yes'></app-header>
    <div class="container">
        <div class="sin-in-page-top">
            <div class="card-wrapper">
                <div class="sin-in-contnt">
                    <div class="sigin-screen-area"><span class="nav-divnk">Change Password</span></div>
                    <div class="content-part">
                        <img src="assets/logo-5.png">
                    </div>
                    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                        <div class="form-group">
                            <input type="number" class="form-control" formControlName="otp" placeholder="Enter otp"
                                [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
                            <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                                <div *ngIf="f.otp.errors.required">{{errorMessage}}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="password" class="form-control" formControlName="password"
                                placeholder="Password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                <div *ngIf="f.password.errors.required">{{errorMessage}}</div>
                            </div>
                        </div>
                        <div class="adjust-div sign-in-button">
                            <button type="submit" class="btn btn-primary">Submit</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</div>